import React from 'react';
import { VehicleDetailsButtonDTO, ClickAction, VehicleDataDTO } from '../../../../api/generated';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { possiblySendMessage, mainColourSelector } from '../../../chatbotSlice';
import { InputType } from '../../../../api/generated';
import { useLinkHandler } from '../../../../app/hooks/useLinkHandler';
import {useGTMTracking} from "../../../../app/hooks/useGTMTracking";

interface VehicleDetailsButtonProps {
  button: VehicleDetailsButtonDTO;
  vehicle: VehicleDataDTO;
  onClose: () => void;
}

const DEFAULT_MAIN_COLOUR = '#0C0126';
const DEFAULT_BUTTONS_COLOUR = '#FFC756';

export const VehicleDetailsButton: React.FC<VehicleDetailsButtonProps> = ({ button, vehicle, onClose }) => {
  const dispatch = useAppDispatch();
  const mainColour = useAppSelector(mainColourSelector);
  const {openLink} = useLinkHandler();
  const {vehicleDetailsButtonClicked} = useGTMTracking();

  const handleClick = () => {
    if (!button.clickAction) return;
    vehicleDetailsButtonClicked(button.buttonText ?? '', button.clickAction);

    switch (button.clickAction) {
      case ClickAction.SendMessage:
        if (button.message) {
          // Note: Replace placeholders in the message with vehicle data from UI
          const processedMessage = button.message
            .replace('{vin}', vehicle.vin || '')
            .replace('{vrm}', vehicle.registration || '')
            .replace('{make}', vehicle.make || '')
            .replace('{model}', vehicle.model || '');

          onClose();

          dispatch(possiblySendMessage({
            message: processedMessage,
            inputType: InputType.Button
          }));
        }
        break;

      case ClickAction.RedirectToDetailsPage:
        if (vehicle.redirect_url) {
          openLink(vehicle.redirect_url, false);
        }
        break;

      default:
        console.warn('Unknown button action:', button.clickAction);
    }
  };

  // Note: Use buttonColour if it appears to be a yellow/gold color, otherwise use default. TMC will use default.
  const isYellow = mainColour === DEFAULT_MAIN_COLOUR;

  const backgroundColor = isYellow ? DEFAULT_BUTTONS_COLOUR : mainColour;

  const textColor = isYellow ? DEFAULT_MAIN_COLOUR : 'white';

  return (
    <button
      onClick={handleClick}
      className="flex-1 px-3 py-2 font-semibold rounded-lg text-base transition-all duration-200 hover:shadow-md"
      style={{
        backgroundColor,
        color: textColor,
      }}
    >
      {button.buttonText || 'Action'}
    </button>
  );
};
